const _ = require('lodash');

function ToggleDirective() {
    return {
        restrict: 'E',
        scope: {
            options: '='
        },
        template: require('./toggle-template.html'),
        require: 'ngModel',
        link(scope, element, attr, ngModelCtrl) {

            scope.toggle = { value: null };
            scope.ctrlName = _.uniqueId('toggle_');

            scope.$watch('toggle.value', (value) => {
                ngModelCtrl.$setViewValue(value);
            });

            ngModelCtrl.$render = () => {
                scope.toggle.value = ngModelCtrl.$viewValue;
            };
        }
    };
}

module.exports = ToggleDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/toggle/toggle-directive.js
 **/